// ===== Drawer Controls =====
function openFilterDrawer() {
  document.getElementById('FilterDrawer').classList.add('active');
}

function closeFilterDrawer() {
  document.getElementById('FilterDrawer').classList.remove('active');
}

// ===== Tag Filter =====
function filterProducts() {
  const selectedTags = Array.from(document.querySelectorAll('input[type="checkbox"]:checked'))
    .map(input => input.value.trim());

  const products = document.querySelectorAll('.grid__item');
  const filterTagsContainer = document.getElementById('FilterTags');
  const appliedFiltersBox = document.getElementById('AppliedFilters');

  filterTagsContainer.innerHTML = '';
  let activeTagCount = 0;

  selectedTags.forEach(tag => {
    const tagElement = document.createElement('span');
    tagElement.textContent = tag;
    tagElement.style = "background:#eee; padding:4px 10px; margin:4px; display:inline-block; border-radius:4px;";
    filterTagsContainer.appendChild(tagElement);
    activeTagCount++;
  });

  appliedFiltersBox.style.display = activeTagCount > 0 ? 'block' : 'none';

  products.forEach(product => {
    const productTags = product.getAttribute('data-tags')?.split(',').map(t => t.trim()) || [];
    const matches = selectedTags.every(tag => productTags.includes(tag));
    product.style.display = (selectedTags.length === 0 || matches) ? 'block' : 'none';
  });
}

// ===== Clear All Filters =====
function clearAllFilters() {
  document.querySelectorAll('input[type="checkbox"]').forEach(input => {
    input.checked = false;
  });
  filterProducts();
}

// ===== Toggle (Accordion Style) =====
function toggleFilter(header) {
  const content = header.nextElementSibling;
  const icon = header.querySelector(".toggle-icon");
  const isOpen = content.style.display === "block";
  content.style.display = isOpen ? "none" : "block";
  icon.textContent = isOpen ? "+" : "-";
}

// ===== Price Filter (with Infinite Max) =====
function applyPriceFilter(minPrice, maxPrice) {
  const products = document.querySelectorAll("#product-grid > li, #product-grid .grid__item");

  products.forEach(product => {
    const price = parseFloat(product.getAttribute("data-price")) || 0;
    const upperLimit = isNaN(maxPrice) ? Infinity : maxPrice; // blank = Infinity
    const show = price >= minPrice && price <= upperLimit;
    product.style.display = show ? "" : "none";
  });

  const visibleProducts = [...products].filter(p => p.style.display !== "none");
  const emptyMessage = document.querySelector(".collection--empty");
  if (emptyMessage) {
    emptyMessage.style.display = visibleProducts.length === 0 ? "block" : "none";
  }
}

// ===== Universal Price Filter Sync (All Instances Stay in Sync) =====
document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll(".price-filter-container");
  if (!containers.length) return;

  // Function to apply filters and sync all instances
  function updateAllFilters(sourceMin, sourceMax) {
    // Sync all instances
    containers.forEach(container => {
      const minInput = container.querySelector(".min-price-display");
      const maxInput = container.querySelector(".max-price-display");
      if (!minInput || !maxInput) return;

      // Update input values everywhere except the one that triggered
      if (minInput !== sourceMin) minInput.value = sourceMin.value;
      if (maxInput !== sourceMax) maxInput.value = sourceMax.value;
    });

    // Apply filter logic
    const minVal = parseInt(sourceMin.value) || 0;
    const maxVal = sourceMax.value.trim() === "" ? NaN : parseInt(sourceMax.value);
    applyPriceFilter(minVal, maxVal);
  }

  // Attach event listeners to every filter container
  containers.forEach(container => {
    const minInput = container.querySelector(".min-price-display");
    const maxInput = container.querySelector(".max-price-display");
    if (!minInput || !maxInput) return;

    const handleInput = () => updateAllFilters(minInput, maxInput);
    minInput.addEventListener("input", handleInput);
    maxInput.addEventListener("input", handleInput);
  });
});
